module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAABFElEQVQoU5WSMUvEUBCEZ18goI0Jgn9BERvBXkQ4bCzTiEUI5r32CrHzTKFgpdfmJRC0UwTBfyL+hSvEu8Le8EZSCEFy8dz+m52ZXdFaLzvnDsuyfMACo7UekPwQY8wmyUdr7VYflyTJuud5NyIyAHD5J6i1XiE5EpFjANcAVgF8zQWzLFOTyeREKZWRfKnr+ryqqqnW+qJx1gmmaborImOSn0qpYZ7nrz8xOsEoipbCMLwjuUPyrCzLp9+5O8GmYQD3ALZJnhZF8bwQ2LKzR3IMYCYiQ2vtW6/VtnoURV4QBKmINGU0m0fW2llvOW2BOI4D3/cb+AjAlXNuTSk1/xwd2TYA3ALYbwTkvy9njDlwzr1/A3zrtbX2sxtSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/audio/leftPlay.png
// module id = GCoj
// module chunks = 1